import { Component, inject } from '@angular/core';
import { VendorsModule } from "../../../../../vendors/src/lib/vendors.module";
import { AuthPathEnum } from '../../@application/enums/auth-path.enum';
import { AuthApiEnum } from '../../@application/enums/auth-api.enum';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ApiBaseService } from '../../../../../vendors/src/lib/services/api-base.service';
import { Router, RouterLink } from '@angular/router';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'lib-sign-up',
    imports: [
        RouterLink,
        VendorsModule,
        ReactiveFormsModule,
        FormsModule
    ],
    templateUrl: './sign-up.component.html',
    styleUrl: './sign-up.component.css'
})
export class SignUpComponent {

  mobileNumber = new FormControl();
  path = AuthPathEnum
  apiBaseService = inject(ApiBaseService)
  router = inject(Router)

  ngOnInit(): void {
    this.mobileNumber = new FormControl(null, [Validators.required])
  }


  onSignIn() {
    this.router.navigate([''])
  }

  submitForm() {
    this.router.navigate([AuthPathEnum.Signup_Verify])
    if (this.mobileNumber.value !== null && this.mobileNumber.value) {
      const user = this.mobileNumber.value;
      const params = new HttpParams()
        .append('mobileNumber', user)
      this.apiBaseService.POST_API([AuthApiEnum.Auth, AuthApiEnum.SignUp], {}, true, true,
        'Successfully Added!', params)
        .subscribe({
          next: value => {
            if(value){
              this.router.navigate([AuthPathEnum.Signup_Verify])
            }
          },
          error: err => {
          }
        })
    }
  }


}
